module.exports = __webpack_public_path__ + "static/img/LI@2x.246ac86f.jpg";